<template>
    <div class="i-prompt">
        <div class="fade" v-show-delay="opened">
            <div class="modal">
                <span class="fal fa-times exit-btn" @click="opened=false"></span>
                <br>
                <div class="title">{{title}}</div>
                <br />
                <div class="text">{{text}}</div>
                <br />
                <input type="text" style='width:100%;' v-model='value' :placeholder="placeholder">
                <br />
                <br />
                <div class="footer" style='float:right'>
                    <btn t='df' s='l' l='Отмена' @press="opened=false" />
                    <btn t='s' s='l' l='ОК' @press="done" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'i-prompt',
    mounted() {
        let self = this;
        _i.bus.$on('prompt', (prompt) => {
            console.log(prompt)
            self.title = prompt.title;
            self.closeOnDone = prompt.closeOnDone;
            self.text = prompt.text;
            self.placeholder = prompt.placeholder;
            self.cb = prompt.cb;
            self.opened = true;
            self.value = "";
        });

        _i.bus.$on('prompt-close', (prompt) => {
            self.opened = !true;
        })
    },
    methods: {
        done() {
            let { value, cb, closeOnDone } = this;
            if (closeOnDone) {
                this.opened = false;
            }
            cb(value);
        }
    },
    data() {
        return {
            opened: false,
            value: "",
            placeholder: "",
            closeOnDone: true,
            title: "TITLE", //
            cb() {},
            text: "TEXT" //
        }
    }
}
</script>
<style lang="css" scoped>
.fade {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    transition: 0.3s all ease;

}

.fade.shown {
    background: rgba(0, 0, 0, 0.75);

}

.modal {
    width: 400px;
    height: 214px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -200px;
    margin-top: -110px;
    background: white;
    border-radius: 6px;
    padding: 6px;
    opacity: 0;
    transition: 0.3s all ease;
    transform: scale(0);
}

.fade.shown .modal {
    opacity: 1;
    transform: scale(1);
}

input {
    border-radius: 6px;
    padding: 6px 12px;
    border: 1px solid lightgrey;
}

.exit-btn {
    float: right;
    cursor: pointer;
}

.exit-btn:hover {
    color: grey;
}

.title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}

.text {
    text-align: center;
    font-size: 16px;
    min-height: 36px;
}
</style>